// extracted by mini-css-extract-plugin
export default {"custom-form-control":"Form_custom-form-control__YYNYH"};